angular.module('lf.desktop')

.controller('StarterKitCtrl', function ($scope,  $timeout, popupsService, productsService, preloadData, helpers) {

  var flow = $scope.flow = lf.data.starterFlow;
  
  $scope.ssoCookieNotFound = flow.ssoCookieNotFound;
  if(typeof(flow.ssoCookieNotFound) != 'undefined' && flow.ssoCookieNotFound) {
	  window.location = lf.data.xhr.siteBaseUrl + '/noParentError.jsp';
	  return;
  }

  $scope.notOwnerError = flow.notOwnerError;
  if(typeof(flow.notOwnerError) != 'undefined' && flow.notOwnerError) {
	  window.location = lf.data.xhr.siteBaseUrl + '/notOwnerError.jsp';
	  return;
  }

  $scope.deviceNotEligibleForStarterApp = flow.deviceNotEligibleForStarterApp;
  if(typeof(flow.deviceNotEligibleForStarterApp) != 'undefined' && flow.deviceNotEligibleForStarterApp) {
	  helpers.utils.lfc.lfcFullScreenAppCenter(1, "skip");
	  return;
  }

  $scope.tabSwitchLFCToFullScreen = function () {
	  helpers.utils.lfc.lfcFullScreenAppCenter(1, "skip");
  }

  $scope.data = {};
  $scope.error = flow.error;

  if ($scope.error) {

    setTimeout(function() { 
		$scope.tabSwitchLFCToFullScreen();
	}, 10000);

    return;
  }
  
  $scope.categories = flow.categories;
  $scope.category = $scope.categories[0];

  $scope.products = $scope.category.products;
  
  $scope.showProductQuickview = function (product) {
    $scope.product = null;
    $timeout(function () {
      $scope.product = product;
      setTimeout(function () {
        popupsService.show('quickview');
      }, 0);
    }, 50);
  }
  
  $scope.showConfirmPopup = function (product) {
    $scope.product = product;
    $timeout(popupsService.show.bind(null, 'confirm'), 50);
  }
  
  $scope.skipStarter = function() {
	  helpers.utils.lfc.lfcFullScreenAppCenter(1, "skip");
  };
  
});
